export default __webpack_public_path__ + "static/media/VitalikButerin.6f0d6fb1.jpeg";